module.exports = __webpack_public_path__ + "static/media/1.da1faaa5.png";